import { Helmet } from 'react-helmet-async'
import { site } from '@/content/site'
import { getSiteUrl } from '@/lib/siteUrl'

type SeoProps = {
  title: string
  description: string
  path?: string
  /** OG image — absolute URL recommended */
  ogImage?: string
  /** Alt text for og:image / twitter:image */
  ogImageAlt?: string
  /** Comma-separated keywords */
  keywords?: string
}

const siteUrl = getSiteUrl()

const DEFAULT_OG_IMAGE = `${siteUrl}/2.jpg`

export function Seo({
  title,
  description,
  path = '',
  ogImage,
  ogImageAlt,
  keywords,
}: SeoProps) {
  const canonical = `${siteUrl}${path.startsWith('/') ? path : `/${path}`}`
  const og = ogImage || DEFAULT_OG_IMAGE
  const imageAlt = ogImageAlt || site.defaultOgImageAlt

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      {keywords ? <meta name="keywords" content={keywords} /> : null}
      <link rel="canonical" href={canonical} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={canonical} />
      <meta property="og:site_name" content={site.name} />
      <meta property="og:locale" content={site.ogLocale} />
      <meta property="og:image" content={og} />
      <meta property="og:image:alt" content={imageAlt} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content={site.twitterSite} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={og} />
      <meta name="twitter:image:alt" content={imageAlt} />
    </Helmet>
  )
}
